// Lib
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@mui/material';

// Components
import sunIcon from '../../../assets/img/sunIcon.png';

import { useStyles } from './ReportableIconStyles';

const ReportableIcon = ({ withText = false }) => {
  const { classes } = useStyles({ withText });

  const sunImage = (
    <div className={classes.imageContainer}>
      <img className={classes.image} src={sunIcon} alt="Sun icon" />
    </div>
  );

  return (
    <>
      {withText ? (
        <div className={classes.container}>
          {sunImage}
          <Typography className={classes.text}>
            Sunshine Act Reportable Item
          </Typography>
        </div>
      ) : (
        <Tooltip
          disableFocusListener
          enterTouchDelay={1}
          leaveTouchDelay={2000}
          title="Sunshine Act Reportable Item."
          arrow
          classes={{
            tooltip: classes.tooltip,
            arrow: classes.arrow,
          }}>
          {sunImage}
        </Tooltip>
      )}
    </>
  );
};

export default ReportableIcon;
